export class Incorporacao {
    valor: number = 0;
    valor_utilizado: number = 0;
    utilizado: boolean = false;
    id_cupom: number = 0;
    created_date;
    created_by:number;
}